import React, { createContext, useContext } from 'react';

type Step = { target: string; content: string };
type Ctx = { start?: (steps: Step[]) => void; stop?: () => void };

const OnbordaCtx = createContext<Ctx>({});

export function OnbordaProvider({ children }: { children: React.ReactNode }) {
  return <OnbordaCtx.Provider value={{}}>{children}</OnbordaCtx.Provider>;
}

export function useOnborda() {
  return useContext(OnbordaCtx);
}



